
import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  mounted() {
    const toc = document.querySelectorAll<HTMLElement>(".mce-toc");

    function findHeight(item: any, toggler: any, menu: any) {
      const togglerHeight = toggler.offsetHeight;
      const menuHeight = menu.offsetHeight;

      item.style.height = togglerHeight + menuHeight + "px";

      return {
        toggler: togglerHeight,
        menu: menuHeight
      };
    }

    function toggleMenu(
      item: any,
      togglerHeight: any,
      menuHeight: any,
      condition: any
    ) {
      if (condition) {
        item.classList.add("close");
        item.style.height = togglerHeight + "px";
      } else {
        item.classList.remove("close");
        item.style.height = togglerHeight + menuHeight + "px";
      }
    }

    if (toc.length) {
      toc.forEach(item => {
        const toggler = item.querySelector("h2");
        const menu = item.querySelector("ul");

        if (toggler && menu) {
          findHeight(item, toggler, menu);
          toggleMenu(
            item,
            findHeight(item, toggler, menu).toggler,
            findHeight(item, toggler, menu).menu,
            window.innerWidth < 768
          );

          toggler.addEventListener("click", () => {
            item.classList.add("cliked");
            toggleMenu(
              item,
              findHeight(item, toggler, menu).toggler,
              findHeight(item, toggler, menu).menu,
              !item.classList.contains("close")
            );
          });
        }
      });
    }
  }

  render() {
    return null;
  }
}
